import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), _mergeProps(_ctx.$attrs, {
    class: [_ctx.classes],
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClick($event))),
    disabled: _ctx.disabled,
    "aria-disabled": _ctx.disabled
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class", "disabled", "aria-disabled"]))
}